


















































import Vue from "vue";
import { City } from "../../types/dossier/City";
import RequiredLabel from "./../interface/RequiredLabel.vue";
import Multiselect from "vue-multiselect";
import { RepositoryFactory } from "./../repositories/RepositoryFactory";
const GeographyRepository = RepositoryFactory.get("geography");

export default Vue.extend({
  name: "city-input",
  components: { Multiselect, RequiredLabel },
  props: {
    id: {
      type: String,
      required: false,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
    },
    value: {
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cities: [] as City[],
      val: "" as string,
    };
  },
  computed: {
    currentCity: {
      get(): string {
        return this.val;
      },
      set(value: string | InputEvent): void {
        if (!(value instanceof InputEvent)) this.val = value;
      },
    },
    citiesOnly(): string[] {
      return this.cities.map((x) => x.deelgemeente);
    },
    isRequired(): boolean {
      return this.required;
    },
  },
  created() {
    this.getGemeenten();
    this.currentCity = this.value as string;
  },
  methods: {
    updateValue(value: string): void {
      this.$emit("input", value);
    },
    async getGemeenten() {
      const { data } = await GeographyRepository.getGemeenten();
      this.cities = data;
    },
  },
  watch: {
    value(newVal) {
      if (!(newVal instanceof InputEvent)) {
        this.val = newVal;
      }
    },
  },
});
